import { svgLinks } from "../../../public/assets/assetLinks.ts";
import { TextSection } from "@/components/custom";
import TestimonialCarousel from "../../components/ui/carousel/testimonial-carousel";

const testimonialData = [
  {
    name: "Aldino Kemal",
    image: svgLinks.aldino,
    quote:
      "I use it every day to scaffold backend logic in Python. It saves me hours and helps me focus on complex problems instead of boilerplate.",
  },
  {
    name: "Aldino Kemal",
    image: svgLinks.aldino,
    quote:
      "Qoonity understands Kotlin structure perfectly. It's like magic — I just type what I need and it writes it out cleanly.",
  },
  {
    name: "Steve Morin",
    image: svgLinks.steve,
    quote:
      "Qoonity understands Kotlin structure perfectly. It's like magic — I just type what I need and it writes it out cleanly.",
  },
  {
    name: "Md. Shah Paran",
    image: svgLinks.shah,
    quote:
      "This tool is like an AI pair programmer. It’s brilliant for debugging and learning better patterns.",
  },
];
export const Developers = () => {
  return (
    <div
      id="testimonials"
      className="lg:px-10 px-5 py-20 items-center justify-center flex-col flex"
    >
      <TextSection
        heading="What Developers Are Saying"
        subtext="Real stories from teams and individuals who’ve supercharged their workflow with Qoonity."
        className="mx-auto"
      />
      <TestimonialCarousel data={testimonialData} speed={60} />
      <TestimonialCarousel data={testimonialData} />
    </div>
  );
};
